import React from "react";
import { useRouter } from "./../util/router";

function IndexPage() {
  const router = useRouter();
  router.replace("/solar/overview");
  return <></>;
}

export default IndexPage;
